import { FEATURE, ROUTES } from '@constants'
import { useGetFeatures } from '@hooks'
import { Layout } from '@layouts'
import * as Page from '@pages'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route>
          <Route element={<Layout />}>
            <Route element={<Page.PlantListPage />} path='/' />
            <Route element={<Page.PlantListPage />} path={ROUTES.PLANT_LIST} />
            <Route element={<Page.DashboardPage />} path={ROUTES.DASHBOARD} />
            <Route element={<Page.DashboardSummaryPage />} path={ROUTES.SUMMARY} />
            <Route element={<Page.DashboardUnavailablePage />} path={ROUTES.DASHBOARD_UNAVAILABLE} />
            <Route element={<Page.AdminDashboardListPage />} path={ROUTES.ADMIN_DASHBOARD.LIST} />
            <Route element={<Page.AdminDashboard />} path={ROUTES.ADMIN_DASHBOARD.DASHBOARD} />
          </Route>
          <Route element={<Page.PlantDetailPage />} path={ROUTES.PLANT_DETAIL} />
          <Route element={<Page.AdminDashboardDetailPage />} path={ROUTES.ADMIN_DASHBOARD.DETAIL} />
        </Route>
        <Route element={<Navigate to='/' />} path='/*' />
      </Routes>
    </BrowserRouter>
  )
}

export default App
